(function($) {
    /**
     * Watch global reservation data
     * @since 2019-09-12
     */
    watch(TL.app.reservation, (prop, method, newValue, oldValue) => {
        switch (prop) {
            case 'propertyId':
                break;
            case 's_checkin':
                $('[name=s_checkin]').val(moment(TL.app.parseDate(newValue)).format('YYYY-MM-DD'))
                $('[name=selectedCheckInDate]').val(moment(TL.app.parseDate(newValue)).format('YYYY-MM-DD'))
                
                var newValueDate = TL.app.parseDate(newValue);               
                reservationCalendar.checkin = newValueDate;
                if (reservationCalendar._init) reservationCalendar.renderRange();
                Reservation.updateCheckin(newValueDate.getFullYear(), newValueDate.getMonth(), newValueDate.getDate(), newValueDate.getDay())
                Reservation.updateNight( reservationCalendar.checkin, reservationCalendar.checkout )
                break;
            case 's_checkout':
                $('[name=s_checkout]').val(moment(TL.app.parseDate(newValue)).format('YYYY-MM-DD'))
                $('[name=selectedCheckOutDate]').val(moment(TL.app.parseDate(newValue)).format('YYYY-MM-DD'))
                var newValueDate = TL.app.parseDate(newValue);               
                reservationCalendar.checkout = newValueDate;
                if (reservationCalendar._init) reservationCalendar.renderRange();
                Reservation.updateCheckout(newValueDate.getFullYear(), newValueDate.getMonth(), newValueDate.getDate(), newValueDate.getDay())
                Reservation.updateNight( reservationCalendar.checkin, reservationCalendar.checkout )
                break;
            case 's_numofroom':
                $('[name=s_numofroom]').val(newValue)
                $('[name=selectedNumberOfRooms]').val(newValue)
                Reservation.updateRoom(newValue)
                1 !== Number(newValue)
                        ? TL.reservation.multiple(true)
                        : TL.reservation.multiple(false)
                break;
            case 's_numofadult':
                $('[name=s_numofadult]').val(newValue)
                $('[name=selectedNumberOfAdults]').val(newValue)
                Reservation.updateAdult(newValue)
                break;
            case 's_numofchild':
                $('[name=s_numofchild]').val(newValue)
                $('[name=selectedNumberOfChildren]').val(newValue)
                Reservation.updateChild(newValue)
                break;
            case 's_accesscode':
                Update.value('[name=s_accesscode]', newValue);
                Update.value('[name=productAccessCodeInput]', newValue)
                break;
            default:
                ;
        }
    })   
    
  /**
   * @global Counter method
   * @since 1.0
   */
    var Counter = {
        get: function(el) {
            if (!$(el).length) return;
            var _el = (typeof el === 'string') ? $(el).get(0) : el;
            return _el.value;
        },
        set: function(el, val) {
            if (!$(el).length) return;
            var _el = (typeof el === 'string') ? $(el).get(0) : el;
            _el.value = val;
        },
        inc: function(el, callback) {
            var _el = $(el).get(0);
            var max = Number(_el.max);
            var cur = Number(this.get(_el));
            if (cur < max) {
                this.set(_el, ++cur);
                $(el).trigger('change');
            }
            if (typeof callback === 'function') {
                callback(cur, max);
            }
        },
        dec: function(el, callback) {
            var _el = $(el).get(0);
            var min = Number(_el.min);
            var cur = Number(this.get(_el));
            if (cur > min) {
                this.set(_el, --cur);
                $(el).trigger('change');
              }
            if (typeof callback === 'function') {
                callback(cur, min);
            }
        }
    }

    /**
     * @global update method
     * @since 1.0
     */
    var Update = {
        text: function(el, text) {
            $(el).text(text);
            return $(el);
        },
        html: function(el, html) {
            $(el).html(html);
            return $(el);
        },
        value: function(el, value) {
            $(el).val(value);
            return $(el);
        }
    }

    var Reservation = {
        state: function() {
            return $('.component-reservation').hasClass('component-reservation--enabled') ? 'enabled' : 'disabled';
        },
        enable: function() {
            $('.component-reservation')
                .addClass('component-reservation--enabled')
                .removeClass('component-reservation--disabled')
                .attr('aria-disabled', false);
        },
        disable: function() {
            $('.component-reservation')
                .addClass('component-reservation--disabled')
                .removeClass('component-reservation--enabled')
                .attr('aria-disabled', true);
        },
        toggle: function() {
            if (this.state() === 'enable') {
                this.disable();
            } else {
                this.enable();
            }
        },
        multiple: function( bool ) {
            if (bool) {
                $('.component-reservation').addClass('component-reservation--multiple');
            } else {
                $('.component-reservation').removeClass('component-reservation--multiple');
            }
        },
        updateCheckin: function(year, month, date) {
            var date = moment([year, month, date]);
            Update.html('.v-date-checkin', `
                <span class="date">${date.format('DD')}</span>
                <span class="month">${date.format('MMM')}</span>
                <span class="year">${TL.ui.localeYear(date.format('YYYY'))}</span>
                <span class="day">${date.format('ddd')}</span>
            `);
            $('[name=checkin]').val(date.format('YYYY-MM-DD'));
        },
        updateCheckout: function(year, month, date) {
            var date = moment([year, month, date]);
            Update.html('.v-date-checkout', `
                <span class="date">${date.format('DD')}</span>
                <span class="month">${date.format('MMM')}</span>
                <span class="year">${TL.ui.localeYear(date.format('YYYY'))}</span>
                <span class="day">${date.format('ddd')}</span>
            `);
            $('[name=checkout]').val(date.format('YYYY-MM-DD'));
        },
        updateAdult: function(num) {
            Update.text('.v-num-adult', num);
            Update.value('[name=s_numofadult], #counter_adult', num);
        },
        updateChild: function(num) {
            Update.text('.v-num-child', num);
            Update.value('[name=s_numofchild], #counter_child', num);
        },
        updateRoom: function(num) {
            Update.text('.v-num-room', num);
            Update.value('[name=s_numofroom], #counter_room', num);
        },
        updateAmount: function(adult, child, room) {
            this.updateRoom(room)
            this.updateAdult(adult)
            this.updateChild(child)
        },
        updateNight: function(checkin, checkout) {
            var num = nightCalc(TL.app.parseDate(checkin), TL.app.parseDate(checkout));
            var unit = num !== 1 ? $('#nightsText').text() : $('#nightText').text();
            Update.html('.v-night', `${num} ${unit}`);
        }
    };
  
    /**
     * @param {Number} number 
     * @param {String} single 
     * @param {String} plural 
     * @since 1.0
     */
    function plural(number, single, plural) {
        return number !== 1 ? plural : single;
    }

    /**
     * Use for calurate number of night(s) between 2 dates
     * @param {Date|String} fromDate 
     * @param {Date|String} toDate 
     * @since 1.0
     */
    function nightCalc(fromDate, toDate) {
        var from = Date.UTC(fromDate.getFullYear(), fromDate.getMonth(), fromDate.getDate());
        var to = Date.UTC(toDate.getFullYear(), toDate.getMonth(), toDate.getDate());
        var diff = to - from;
        var night = diff < 0 ? Math.abs(diff) : diff;
        return Math.round(night / (1000 * 60 * 60 * 24));
    }

    function initHotelSelectEvents() {
        /**
         * Hotel Properties Select
         * @since 1.0
         */
        $('.js-hotel-select').on('change', function(event) {
            var el = event.currentTarget;
            var label = el.children[el.selectedIndex].label;
            var $display = $(el).next('.hotel-selected');
            $display.html(`<span class="text" title="${label}">${label}</span>`);
            TL.app.reservation.set('propertyId', el.value)
        });
        
        // Trigger a change onload
        $('.js-hotel-select').trigger('change');
    }
  
    var initAmountCounterEvents = function() {
        /**
         * Counter
         */
        $('[data-counter]').on('click', function() {
            var el = this;
            var target = this.dataset.counter;
            var control = this.dataset.counterControl;
            var visual = this.dataset.counterVisual;
            var value = this.dataset.counterValue;

            switch(control) {
                case 'increase':
                    Counter.inc(target, function(number) {
                        Update.text(visual, number);
                        Update.value(value, number);
                    });
                    break;
                case 'decrease':
                    Counter.dec(target, function(number) {
                        Update.text(visual, number);
                        Update.value(value, number);
                    });
                    break
            }
        });
    }
    
    /**
     * Reservation Calendar
     * @since 1.0
     */
    var is_buddhist = (lang) => {
        let language_codes = ['th']
        return language_codes.includes(lang);
    }

    var calendarAPI = TL.app.calendar;
    var reservationAPI = TL.app.reservation;
    var reservationCalendar = new Calendar('#reservation_calendar', {
        children: '.calendar',
        mode: 'datepicker',
        buddhist: is_buddhist(localData.h_lang),
        minDate: TL.app.getPropertyToday(),
        weekdayName: moment.weekdaysMin(),
        monthName: moment.months(),
        navigation: {
            nextText: '<i class="far fa-chevron-right"></i>',
            prevText: '<i class="far fa-chevron-left"></i>'
        },
    });

    reservationCalendar.checkin = calendarAPI.checkin;
    reservationCalendar.checkout = calendarAPI.checkout;

    /**
     * ใช้สำหรับจัดตำแหน่ง baloon tail ของ reservation calendar
     * @param {selector} el jQuery selector
     */
     const activeDate = el => {
        let $el = $(el)
        let _el = $el.get(0)
        let pos = $el.position()
        let cord = _el.getBoundingClientRect()
        let ctr = pos.left + cord.width / 2
        $el.addClass('is-active')
        $el.siblings().removeClass('is-active')
        if ($('#reservation_calendar').hasClass('show')) {
            $('#reservation_calendar_arrow').stop().animate({ left: ctr }, 150)
        } else {
            $('#reservation_calendar_arrow').css('left', ctr)
        }
    }
    
    var initReservationCalendarEvents = function() {
        /**
         * @description
         * เมื่อ Reservation Calendar `READY` (เลือกวัน checkin-checkout ครบแล้ว)
         * ให้อัปเดต UI ของ Reservation Bar
         */
        $('#reservation_calendar').on('ready', ev => {
            let {checkin, checkout} = ev.detail;
            reservationAPI.set('s_checkin', checkin);
            reservationAPI.set('s_checkout', checkout);
        });

        /**
         * @description
         * Try to create tippy instance on date buttons
         */
        // $('#reservation_calendar').on('render', ev => {
        //     let $date = $(ev.currentTarget).find('[data-date]')
        //     for (var i = 0; i < $date.length; i++) {
        //         var _this = $date[i]
        //         new tippy(_this, {
        //             content: 'Hoo Lay!',
        //             theme: 'light',
        //             arrow: true,
        //         })
        //     }
        // })
        
        /**
         * @description
         * เมื่อ Reservation Calendar มีการเปลี่ยน state ให้อัปเดตตำแหน่ง baloon tail
         */
        $('#reservation_calendar').on('stateChange', ev => {
            switch (ev.detail) {
                case 'select_checkin':
                case 'select_checkin_only':
                    activeDate( '.v-date-checkin' )
                    break;
                case 'select_checkout':
                case 'select_checkout_only':
                    activeDate( '.v-date-checkout' )
                    break;
                default:;
            }

            if ('ready' === ev.detail) {
                $('#reservation_calendar').collapse('hide')
            }
        })

        $('#reservation_calendar').on('show.bs.collapse', ev => {
            let date = reservationCalendar.checkin
            reservationCalendar.inView( date )
                ? reservationCalendar.renderRange()
                : reservationCalendar.goto(date.getFullYear(), date.getMonth())
        })
        
        /**
         * ลบคลาส `is-active` จากปุ่มแสดงวันเช็กอิน-เช็กเอาต์ใน Reservation bar
         * @since 2020-04-23
         */
        $('.component-reservation__calendar').on('hide.bs.collapse', function(event) {       
           $('.v-date').removeClass('is-active')

           // ลบอีเวนต์จาก #home_calendar
           $('#home_calendar').off('click.home_calendar');
        });

        /**
        * Close another collapse in reservation component when trigger a collapse
        * @since 1.0
        */
        $('.component-reservation .collapse').on('show.bs.collapse', function(event) {
           var self = event.currentTarget;
           $('.component-reservation .collapse').not(self).collapse('hide');

           // ปิด calendar ถ้ายูเซอร์พลาดไปคลิกที่ #home_calendar
           $('#home_calendar').on('click.home_calendar', () => {
               $('.component-reservation .collapse').collapse('hide')
           });
        });
    }
    
    /**
     * @description
     * bind อีเวนต์ในจุดต่าง ๆ เพื่อใช้เป็น trigger ในการปรับ state ของ Reservation Calendar
     */
    $(document).on('click', '.js-reservation-calendar-toggle', event => {
        let el = event.currentTarget
        // if ($(el).closest('[aria-disabled=true]').length) return

        let target = event.target;
        let $panel = $(el.dataset.target);
        let isShown = $(el.dataset.target).hasClass('show')

        let methods = {
            selectCheckin() {
                
                $panel.collapse('show');
                activeDate('.v-date-checkin');
                reservationCalendar.state = 'select_checkin';
                reservationCalendar.render();
                
                selectReservationCalendarCheckinDateRemoteCommand();
            },
            selectCheckout() {
                
                $panel.collapse('show');
                activeDate('.v-date-checkout');
                reservationCalendar.state = 'select_checkout_only';
                reservationCalendar.render();
                
                selectReservationCalendarCheckoutDateRemoteCommand();
            },
            selectComplete() {
                $panel.collapse('hide');
            }
        }

        if ($(target).closest('.v-date-checkin').length) {
            $(target).closest('.is-active').length
                ? methods.selectComplete()
                : methods.selectCheckin()
        } else if ($(target).closest('.v-date-checkout').length) { 
            $(target).closest('.is-active').length
                ? methods.selectComplete()
                : methods.selectCheckout()
        } else {   
            isShown
                ? methods.selectComplete()
                : methods.selectCheckin()
        }
    });

    $(document).on('click', '.js-reservation-amount-toggle', event => {
        let el = event.currentTarget
        // if ($(el).parents('[aria-disabled=true]').length) return

        $(el.dataset.target).collapse('toggle')
    });

    /**
     * When click on anything what's not the collapse
     * then close all collapses in reservation component
     * @since 1.0
     */
    $(document).on('click', function(event) {
        var excerpt = '.component-reservation__calendar, .component-reservation__amount, .btn-day';
        if (!$(event.target).closest(excerpt).length) {
            $('.component-reservation .collapse.show').collapse('hide');
        }
    });

    
    /**
     * Click anywhere of reservation component to enable
     * @since 2019-04-10
     */
    $(document).on('click', '.component-reservation', function(event) {
        var excerpt = '.component-reservation__search__button';
        if (
            'disabled' === Reservation.state() &&
            !$(event.target).closest(excerpt).length
        ) {
            Reservation.enable();
        }
    });

    $('#toggle_summary_list').on('click', function() {
        console.log(this);
    })
    
   
    var initReservationCalendarWhenSelectCheckinDate = function () {
        reservationCalendar.state = 'select_checkin';
        reservationCalendar.render();
    };
    
    var initReservationCalendarWhenSelectCheckoutDate = function () {
        reservationCalendar.state = 'select_checkout_only';
        reservationCalendar.render();
    };
    
    var initPropertyDailyAvailability = function() {
        
        $('#reservation_calendar').on('render', ev => {
            
            let listNotAvailable = window.ListNotAvailable;
            if (listNotAvailable) {
                for (var i = 0; i < listNotAvailable.length; i++) {
                    let date = listNotAvailable[i];
                    let $el = $('#reservation_calendar').find(`[data-date-format="${date}"]`);
                    $el.parent().addClass('is-disabled is-disabled-date');
                }
            }

            let listAvailable = window.ListAvailable;
            if (listAvailable) {

            var hasDisplayTotalPriceBeforeTax = $('#display-total-price-before-tax').val() === 'true';

            var $dates = Array.prototype.slice.call(document.querySelectorAll('#reservation_calendar [data-date-format]'));
            $dates.forEach(function (date) {

                var isDisabled = date.closest('td.is-disabled');
                if (isDisabled) {
                    return; //If the date is disabled then skip!
                }

                var _pda$find = listAvailable.find(function (price) {
                    return price.forDate === date.dataset.dateFormat;
                });

                if (!_pda$find) {
                    return;
                }

                var price = hasDisplayTotalPriceBeforeTax ? _pda$find.startingPrice.price : _pda$find.startingPrice.finalPrice;
                if (price === 0 || price == '0') {
                    return;
                }

                var hasPriceDom = date.querySelector('span.price');
                if (hasPriceDom) {
                    // Just append price to existing dom
                    date.querySelector('span.price').innerHTML = formatNumber(price);
                } else {
                    // Create span.price dom and append to the buttom
                    var priceDom = document.createElement('span');
                    priceDom.classList.add('price', 'd-block', 'small');
                    priceDom.innerHTML = formatNumber(price);
                    date.appendChild(priceDom);
                }
            });
        }
        
        });
    }
    
    const formatNumber = n => {
        let decimalPlaces = 1;
        if (n < 1e5) {
            return formatNumberWithComma(n);
        } else {
            return formatNumberWithSymbol(n, decimalPlaces);
        }
    };

    function formatNumberWithComma(number) {
        var parts = Math.round(number).toString().split(".");
        return parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }

    //Format number with symbol
    //1e3  = 1,000
    //1e4  = 10,000
    //1e5  = 100,000
    //1e6  = 1,000,000
    //1e9  = 1,000,000,000
    //1e12 = 1,000,000,000,000
    function formatNumberWithSymbol(num, digits) {
        const lookup = [
            {value: 1, symbol: ""},
            {value: 1e3, symbol: "K"},
            {value: 1e6, symbol: "M"},
            {value: 1e9, symbol: "G"},
            {value: 1e12, symbol: "T"},
            {value: 1e15, symbol: "P"},
            {value: 1e18, symbol: "E"}
        ];
        const rx = /\.0+$|(\.[0-9]*[1-9])0+$/;
        var item = lookup.slice().reverse().find(function (item) {
            return num >= item.value;
        });
        return item ? (num / item.value).toFixed(digits).replace(rx, "$1") + item.symbol : "0";
    }
    
    var initReservationCalendar = function() {
        let {checkin, checkout} = reservationCalendar;
        Reservation.updateCheckin( checkin.getFullYear(), checkin.getMonth(), checkin.getDate() );
        Reservation.updateCheckout( checkout.getFullYear(), checkout.getMonth(), checkout.getDate() );   
    }
    
    var handleNumberOfChildSelectionButton = function() {
        var maxchild = $('#h_maxchild').val();
        var counterDownChild = $('#counter_down_child');
        var counterUpChild = $('#counter_up_child');

        if (maxchild === "0") {
            counterDownChild.prop('disabled', true);
            counterUpChild.prop('disabled', true);

        } else {
            counterDownChild.prop('disabled', false);
            counterUpChild.prop('disabled', false);
        }
    }
             
    var initReservationBar = function() {
        reservationCalendar.weekDayName = moment.weekdaysMin();
        reservationCalendar.monthName = moment.months();
        reservationCalendar.buddhist = is_buddhist(localData.h_lang);
        reservationCalendar.init(true);
        let reservationAPI = TL.app.reservation;
        Reservation.updateAmount( reservationAPI.get('s_numofadult'), reservationAPI.get('s_numofchild'), reservationAPI.get('s_numofroom') );
        Reservation.updateNight( reservationAPI.get('s_checkin'), reservationAPI.get('s_checkout') );
        initHotelSelectEvents();
        initPropertyDailyAvailability();
        initReservationCalendarEvents();
        initAmountCounterEvents();
        handleNumberOfChildSelectionButton();
    }
    
    initReservationBar();
    
    $(document).ready( function() {    
        TL.app.reservation.set('s_checkin', TL.app.parseDate(localData.h_checkin));
        TL.app.reservation.set('s_checkout', TL.app.parseDate(localData.h_checkout)); 
    });

    if ('undefined' === typeof window.InitReservationBar) {
        window.InitReservationBar = initReservationBar;
    }

    if ('undefined' === typeof window.InitReservationCalendar) {
        window.InitReservationCalendar = initReservationCalendar;
    }
    
    if ('undefined' === typeof window.InitPropertyDailyAvailability) {
        window.InitPropertyDailyAvailability = initPropertyDailyAvailability;
    }
    
    if ('undefined' === typeof window.InitReservationCalendarWhenSelectCheckinDate) {
        window.InitReservationCalendarWhenSelectCheckinDate = initReservationCalendarWhenSelectCheckinDate;
    }
    
    if ('undefined' === typeof window.InitReservationCalendarWhenSelectCheckoutDate) {
        window.InitReservationCalendarWhenSelectCheckoutDate = initReservationCalendarWhenSelectCheckoutDate;
    }

    /**
     * Assign method to global
     * @since 2016-06-10
     */
    $.extend(true, window.TL, {
        counter: Counter,
        update: Update,
        reservation: Reservation
    })
})(jQuery);